export default __webpack_public_path__ + "static/media/2.abedc894.png";